import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { MailAccount } from '../../comunications/_types/mail-account';
import { MailAccountsService } from '../../comunications/_services/mail-account.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { Validators } from '@angular/forms';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';

@Component({
    selector: 'app-mails-account-detail',
    templateUrl: './mails-account-detail.component.html',
    styleUrls: ['./mails-account-detail.component.css'],
    standalone: false
})
export class MailsAccountDetailComponent implements OnInit {
  public mailAccountFormGroup!: RxFormGroup;
  public mailAccount: MailAccount = new MailAccount();  
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public currentSystemMailAccountName: string | null = null;

  constructor(
    private mailAccountsService: MailAccountsService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {
    this.mailAccountFormGroup = this.formBuilder.formGroup<MailAccount>(this.mailAccount) as RxFormGroup;
   }

  ngOnInit() {
    let id = this.config.data.id;
    if(id){
      this.loadData(id);
    }else{
      this.loadCurrentSystemMailAccount();
    }
    this.allowWrite = this.loginService.hasPermission("MAIL_ACCOUNTS.WRITE");
    this.allowDelete = this.loginService.hasPermission("MAIL_ACCOUNTS.DELETE");
  }

  async loadData(id: string) {
    this.mailAccount = await firstValueFrom(this.mailAccountsService.get(id));
    this.mailAccountFormGroup.patchValue(this.mailAccount);
    await this.loadCurrentSystemMailAccount();
  }

  //solo puede haber una cuenta de sistema: si ya hay otra, avisamos de que al guardar perdera el flag
  async loadCurrentSystemMailAccount() {
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject({
        isSystem: new Filter(FilterOperation.equals, 'isSystem', '', true)
      }).build()
    };
    let response = await firstValueFrom(this.mailAccountsService.all(params));
    let systemMailAccount = response.data.find((m: any) => m.id != this.mailAccount.id);
    this.currentSystemMailAccountName = systemMailAccount ? systemMailAccount.name : null;
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  
  async save() {
    let valid = this.formValidationService.validateForm(this.mailAccountFormGroup);
    if (valid) {
      this.mailAccount = Object.assign(this.mailAccount, this.mailAccountFormGroup.value);
      let mailAccountsService = await firstValueFrom(this.mailAccountsService.save(this.mailAccount));

      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Cuenta de correo guardada correctamente." });
      this.dynamicDialogRef.close();

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  imapChecked($event: any, type: string){
    if($event.checked){
        if(type=="smtp"){
          this.mailAccountFormGroup.controls['smtpFrom'].setValidators([Validators.required]);
          this.mailAccountFormGroup.controls['smtpHost'].setValidators([Validators.required]);
          this.mailAccountFormGroup.controls['smtpPort'].setValidators([Validators.required]);
        }else{
          this.mailAccountFormGroup.controls['imapHost'].setValidators([Validators.required]);
          this.mailAccountFormGroup.controls['imapPort'].setValidators([Validators.required]);
        }
          
    }else{
      if(type=="smtp"){
        this.mailAccountFormGroup.controls['smtpFrom'].clearValidators();
        this.mailAccountFormGroup.controls['smtpHost'].clearValidators();
        this.mailAccountFormGroup.controls['smtpPort'].clearValidators();
      }else{
        this.mailAccountFormGroup.controls['imapHost'].clearValidators();
        this.mailAccountFormGroup.controls['imapPort'].clearValidators();
      }
    }
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea la cuenta de correo?",
      header: "Eliminar cuenta de correo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.mailAccountsService.delete(this.mailAccount.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Cuenta de correo eliminada correctamente." });
            this.dynamicDialogRef.close();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }
}
